export default __webpack_public_path__ + "static/media/featured-item-14.42edd39e.png";